module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-feed"
    }
  }, [(_vm.gotInitialLoggedUserInfo) ? _c('article', {
    attrs: {
      "id": "feed-posts-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "feed-post-collection"
    }
  }, [_c('div', {
    staticClass: "single-column-container"
  }, [(_vm.fetchingStatus === 'fetched' && _vm.isLoggedIn) ? _c('new-post-form') : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
    return [_c('feed-status-post', {
      key: feedPost.id,
      attrs: {
        "data": feedPost.post
      }
    })]
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "load-more-button-container"
  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
    attrs: {
      "id": "feed-fetch-more"
    },
    on: {
      "click": _vm.getPosts
    }
  }, [_vm._v("Load more posts")]) : _vm._e(), _vm._v(" "), (_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e()], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4115de8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/BlogFeed/BlogFeed.vue
// module id = 909
// module chunks = 2